import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { List, Record, fromJS } from 'immutable';
import { IOrderSearch } from '@server/data/models/order';
import FragmentOrderSearch from '@graphql/fragments/order-search.gql';
import FragmentOrderProduct from '@graphql/fragments/order-detail-product.gql';
import FragmentOrderShipping from '@graphql/fragments/order-detail-shipping.gql';
import FragmentOrderBilling from '@graphql/fragments/order-detail-billing.gql';

export const QUERY = gql`
  query SearchOrder($type: Int!, $value: String!, $recaptchaResponse: String!) {
    orderSearch(
      type: $type
      value: $value
      recaptchaResponse: $recaptchaResponse
    ) {
      ...OrderSearch
      shippingInfo {
        ...OrderDetailShipping
      }
      billingInfo {
        ...OrderDetailBilling
      }
      products {
        ...OrderProduct
      }
    }
  }
  ${FragmentOrderSearch}
  ${FragmentOrderProduct}
  ${FragmentOrderShipping}
  ${FragmentOrderBilling}
`;

interface OrderSearchResponse {
  loading: boolean;
  error: boolean;
  result?: List<IOrderSearch>;
  refetch: any;
  search: (options: any) => void;
}

export const useOrderSearch = (variables: any): OrderSearchResponse => {
  const [search, { loading, error, data, refetch }] = useLazyQuery(QUERY, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  let result = List();

  if (!!data) {
    if (!!data.orderSearch) {
      result = fromJS(data.orderSearch);
    }
  }

  return {
    search,
    error: !!error,
    result,
    loading,
    refetch,
  };
};

export default useOrderSearch;
